import React from 'react';
import { X } from 'lucide-react';
import { useIDEStore } from '@/stores/useIDEStore';
import { cn } from '@/utils/cn';

export default function EditorTabs() {
  const { openFiles, activeFile, setActiveFile, closeFile } = useIDEStore();

  if (openFiles.length === 0) return null;

  return (
    <div className="flex items-center border-b bg-muted/30 overflow-x-auto">
      {openFiles.map((file) => {
        const fileName = file.path.split('/').pop() || file.path;
        const isActive = activeFile === file.path;

        return (
          <div
            key={file.path}
            className={cn(
              'flex items-center gap-1.5 px-3 py-1.5 text-xs border-r cursor-pointer',
              'hover:bg-muted/50 shrink-0',
              isActive ? 'bg-background border-b-2 border-b-primary' : 'text-muted-foreground'
            )}
            onClick={() => setActiveFile(file.path)}
          >
            {file.isDirty && <span className="w-1.5 h-1.5 rounded-full bg-blue-400" />}
            <span className="truncate max-w-[120px]">{fileName}</span>
            <button
              className="ml-1 hover:bg-muted rounded p-0.5"
              onClick={(e) => {
                e.stopPropagation();
                closeFile(file.path);
              }}
            >
              <X className="h-3 w-3" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
